import classNames from 'classnames'
import React, { useState } from 'react'
import useIsTablet from '../../modules/hooks/common/useIsTablet'
import CenterContainer from '../common/CenterContainer'

interface MainTitleType {
  title: React.ReactNode
  bgImg?: string
  bgImgAlt?: string
  button?: React.ReactNode
  className?: string
  bgClx?: string
  dark?: boolean
  darkNormal?: boolean
  deepDark?: boolean
  objectRight?: boolean
}

const MainTitle: React.FC<MainTitleType> = ({
  title,
  bgImg,
  bgImgAlt = 'main image',
  button,
  className,
  bgClx,
  dark,
  deepDark,
  darkNormal,
  objectRight,
}) => {
  const [isTablet, setIsTablet] = useIsTablet()
  const [imgError, setImgError] = useState(false)
  return (
    <div
      style={{ zIndex: '1' }}
      className={classNames(`${bgClx} sm:text-left`, 'relative h-[508px] overflow-hidden text-center')}
    >
      <div className="absolute left-[0px] right-[0px] top-[0px] -z-10 h-full overflow-hidden">
        <img
          src={bgImg}
          alt={bgImgAlt}
          onError={() => setImgError(true)}
          className={classNames(
            classNames('h-full w-full object-cover', { hidden: imgError }, { 'object-right': objectRight })
          )}
        />
      </div>
      <CenterContainer
        style={{ height: '508px' }}
        className={classNames('flex flex-col', className, {
          'py-104': !isTablet,
          'pb-280 pt-20': isTablet,
        })}
        clx="z-10"
      >
        {title && title}
        <div className="mdd:absolute mdd:bottom-24 mdd:w-full mdd:left-0">{button && button}</div>
      </CenterContainer>
      {dark && (
        <div
          style={{
            backgroundImage: 'linear-gradient(to right, rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0) 62%)',
          }}
          className="absolute left-[0px] right-[0px] top-[0px] -z-10 h-full overflow-hidden"
        ></div>
      )}
      {darkNormal && (
        <div
          style={{
            backgroundImage: 'linear-gradient(to right, rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0) 90%)',
          }}
          className="absolute left-[0px] right-[0px] top-[0px] -z-10 h-full overflow-hidden"
        ></div>
      )}
      {deepDark && (
        <div
          style={{
            backgroundImage:
              'radial-gradient(circle at 100% 50%, rgba(255, 255, 255, 0.5), rgba(0, 0, 0, 0.5) 38%), linear-gradient(to bottom, rgba(28, 29, 63, 0.68), rgba(28, 29, 63, 0.68))',
          }}
          className="absolute left-[0px] right-[0px] top-[0px] -z-10 h-full overflow-hidden"
        ></div>
      )}
    </div>
  )
}

export default MainTitle
